import type { FaireProductEntity } from "../../entity_types/product";

export const p_eilldhxk54: FaireProductEntity = {
  token: "p_eilldhxk54",
  type: "product",
  name: "DEEP SLEEP SUPPORT | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cc93e4eb92c905c9bffc7bae43d5885de2f44cf8403ebf2c9842642a7d478f63.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ffd061bfa8da8f986f60618d7a566d81c067047334152ac837556d7c6a85a7a.png",
  ],
  priceDollars: 17,
  description:
    'This 100% pure, therapeutic grade essential oil wellness blend promotes feelings of relaxation and a restful night\'s sleep as cedarwood and lavender trigger the release of serotonin in the brain which converts to melatonin, the sleep hormone.\n\nTO USE: Apply desired amount onto inner wrists, forehead, or under nose before sleep.\n\nINGREDIENTS: ORGANIC UNREFINED COLD PRESSED AVOCADO OIL, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: LAVENDER, CEDARWOOD, ROMAN CHAMOMILE.\n \nDimension: 10 ml, 0.75" x 3.25" x 0.75".',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:31.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
